import { render } from "./AttendanceAlert.vue?vue&type=template&id=311bc998&ts=true"
import script from "./AttendanceAlert.vue?vue&type=script&lang=ts"
export * from "./AttendanceAlert.vue?vue&type=script&lang=ts"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__